import { render, staticRenderFns } from "./DownloadIcon.vue?vue&type=template&id=c2d3dd5a"
import script from "./DownloadIcon.vue?vue&type=script&lang=ts"
export * from "./DownloadIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports